import { Component, Input, OnInit } from '@angular/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-display-rubrique-status',
  templateUrl: './display-rubrique-status.component.html',
  styleUrls: ['./display-rubrique-status.component.scss'],
  standalone: true,
  imports: [IonItem, IonLabel, IonList, TranslatePipe],
})
export class DisplayRubriqueStatusComponent {
  @Input() title: string = '';
  @Input() value: string = '';

  constructor() {}
}
